import React, { useContext } from 'react'
import { LogoContext } from '../../contexts/LogoContext';

const LinkLogo = () => {
    const { logos, dispatch } = useContext(LogoContext);

    const linkHandler = event => {
        event.preventDefault();
        dispatch({ type: 'UPDATE_WEB_URL', url: event.target.value}); 
    }

    const logoSizeHandler = event => {
        event.preventDefault();
        dispatch({ type: 'UPDATE_WEB_WIDTH', width: event.target.value})
    }
    return ( 
        <div className="link-logo">
            <input 
                placeholder="Paste in Logo URL"
                type="text" 
                onChange={linkHandler}
                value={logos.webUrl}
                style={{height:'21px'}}
                />
                <br/>
            <br/>
            <input 
                id="logo-width"
                type="text"
                onChange={logoSizeHandler}
                value={logos.webWidth}
                style={{width:'30px'}}
            />
            <small>
                <label id="logo-width">% Logo Size</label>
            </small>
        </div>
     );
}
 
export default LinkLogo;